// @ vendors
const get = require('lodash/object/get');
//@constants
const actionTypes = require('constants/actionTypes');
const signaturePatternActions = require('actions/signaturePattern');
const { FIRST_STEP } = require('constants/index');
//@utilities
const { APIGet, APIPost } = require('utilities/APIRequestHelper');

const setDefaultInstallmentQuantity = totalAmount => ({
    type: actionTypes.CARD_PAYMENT_PURCHASE_DEFERRAL_SET_DEFAULT_INSTALLMENTS_QUANTITY,
    payload: {
        totalAmount
    }
});

const setVisibleStep = step => ({
    type: actionTypes.CARD_PAYMENT_PURCHASE_DEFERRAL_SET_VISIBLE_STEP,
    payload: { step }
});

const validateStep = step => ({
    type: actionTypes.CARD_PAYMENT_PURCHASE_DEFERRAL_VALIDATE_STEP,
    payload: { step }
});

const setWillCancel = willCancel => ({
    type: actionTypes.CARD_PAYMENT_PURCHASE_DEFERRAL_WILL_CANCEL,
    payload: { willCancel }
});

const clearRequest = () => ({ type: actionTypes.CARD_PAYMENT_PURCHASE_DEFERRAL_CLEAR });

const requestRepayment = () => ({ type: actionTypes.CARD_REPAYMENT_REQUEST });

const requestRepaymentSuccess = (data, cardId) => ({
    type: actionTypes.CARD_REPAYMENT_SUCCESS,
    payload: {
        data,
        cardId
    }
});

const requestRepaymentFailure = error => ({
    type: actionTypes.CARD_REPAYMENT_FAILURE,
    payload: { error: error.description }
});

const setDeferralOption = option => ({
    type: actionTypes.CARD_PAYMENT_PURCHASE_SET_DEFERRAL_OPTION,
    payload: { option }
});

const getSpecificQuotaRequest = () => ({
    type: actionTypes.CARD_PAYMENT_PURCHASE_DEFERRAL_SPECIFIC_QUOTA_REQUEST
});

const setSpecificQuotaAmount = amount => ({
    type: actionTypes.CARD_PAYMENT_PURCHASE_DEFERRAL_SPECIFIC_QUOTA_AMOUNT,
    payload: { amount }
});

const fetchRepayment = (cardId, movementId) => (dispatch, getState) => {
    const immCard = getState().cards.getIn(['byId', cardId]);
    const immMovement = getState().cardsTransactions.getIn([cardId, 'byId', movementId]);
    const immCardPaymentPurchaseDeferral = getState().cardPaymentPurchaseDeferral;

    if (!immCardPaymentPurchaseDeferral.get('isFetching')) {
        const standard = immCard.getIn(['product', 'standard']);
        const standardShort = standard.substr(standard.length - 3);
        const params = {
            query: {
                numPlazosSeleccionados: immCardPaymentPurchaseDeferral.getIn([
                    'steps',
                    FIRST_STEP,
                    'installmentQuantity'
                ]),
                fechaOperacion: immMovement.getIn(['extra', 'operationDate']),
                importeOpeacion: immMovement.getIn(['import', 'amount']),
                divisaOperacion: immMovement.getIn(['import', 'currency']),
                operacionBasica: immMovement.getIn(['extra', 'basicOperationCode']),
                operacionBancaria: immMovement.getIn(['extra', 'bankOperationCode']),
                fechaAnotacion: immMovement.getIn(['extra', 'movementNoteDay']),
                tipoSaldo: immMovement.getIn(['extra', 'balanceConcept']),
                estadoOperacion: immMovement.getIn(['extra', 'petitionState']),
                diaOperacion: immMovement.getIn(['extra', 'dayMovementNumber']),
                fechaLiquidacion: immMovement.get('settlementDate'),
                productoTarjeta: immCard.getIn(['product', 'type']),
                numeroContratoTarjeta: immCard.getIn(['contract', 'number']),
                estandarTipo: standardShort,
                estandarSubTipo: immCard.getIn(['product', 'subtype'])
            }
        };

        dispatch(requestRepayment());
        return APIGet({
            dispatch,
            params,
            endpoint: 'getCardRepayment'
        })
            .then(response => dispatch(requestRepaymentSuccess(response, cardId)))
            .catch(response => {
                if (!!response.error) {
                    dispatch(requestRepaymentFailure(response.error));
                } else {
                    throw response;
                }
            });
    }
};

const fetchSpecificRepayment = (cardId, movementId) => (dispatch, getState) => {
    dispatch(getSpecificQuotaRequest());
    const immCard = getState().cards.getIn(['byId', cardId]);
    const immMovement = getState().cardsTransactions.getIn([cardId, 'byId', movementId]);
    const immCardPaymentPurchaseDeferral = getState().cardPaymentPurchaseDeferral;

    if (!immCardPaymentPurchaseDeferral.get('isFetching')) {
        const standard = immCard.getIn(['product', 'standard']);
        const standardShort = standard.substr(standard.length - 3);
        const params = {
            query: {
                numPlazosSeleccionados: 3,
                fechaOperacion: immMovement.getIn(['extra', 'operationDate']),
                importeOpeacion: immMovement.getIn(['import', 'amount']),
                divisaOperacion: immMovement.getIn(['import', 'currency']),
                operacionBasica: immMovement.getIn(['extra', 'basicOperationCode']),
                operacionBancaria: immMovement.getIn(['extra', 'bankOperationCode']),
                fechaAnotacion: immMovement.getIn(['extra', 'movementNoteDay']),
                tipoSaldo: immMovement.getIn(['extra', 'balanceConcept']),
                estadoOperacion: immMovement.getIn(['extra', 'petitionState']),
                diaOperacion: immMovement.getIn(['extra', 'dayMovementNumber']),
                fechaLiquidacion: immMovement.get('settlementDate'),
                productoTarjeta: immCard.getIn(['product', 'type']),
                numeroContratoTarjeta: immCard.getIn(['contract', 'number']),
                estandarTipo: standardShort,
                estandarSubTipo: immCard.getIn(['product', 'subtype'])
            }
        };
        return APIGet({
            dispatch,
            params,
            endpoint: 'getCardRepayment'
        })
            .then(response => {
                    const parseAmountObject = (obj) => ({
                    amount: obj.importe,
                    currency: obj.divisa
                })
                dispatch(setSpecificQuotaAmount(parseAmountObject(get(response, 'lista.dato[0].impTotalCuota'))))
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(requestRepaymentFailure(response.error));
                } else {
                    throw response;
                }
            });
    }
};

const setQuotaQuantity = (installmentQuantity, cardId, movementId) => dispatch => {
    dispatch({
        type: actionTypes.CARD_PAYMENT_PURCHASE_SET_QUOTA_QUANTITY,
        payload: {
            installmentQuantity
        }
    });

    dispatch(fetchRepayment(cardId, movementId));
};

const confirmDeferralRequest = () => ({
    type: actionTypes.FETCH_CARD_PAYMENT_PURCHASE_DEFERRAL_CONFIRMATION_REQUEST
});

const confirmDeferralSuccess = () => ({
    type: actionTypes.FETCH_CARD_PAYMENT_PURCHASE_DEFERRAL_CONFIRMATION_SUCCESS
});

const confirmDeferralFailure = error => ({
    type: actionTypes.FETCH_CARD_PAYMENT_PURCHASE_DEFERRAL_CONFIRMATION_FAILURE,
    payload: { error }
});

const confirmDeferral = (cardId, movementId) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const immCard = getState().cards.getIn(['byId', cardId]);
        const immMovement = getState().cardsTransactions.getIn([cardId, 'byId', movementId]);
        const immCardPaymentPurchaseDeferral = getState().cardPaymentPurchaseDeferral;

        const params = {
            query: {
                dataToken,
                codOpera: {
                    operacionbancaria: immMovement.getIn(['extra', 'bankOperationCode']),
                    operacionbasica: immMovement.getIn(['extra', 'basicOperationCode'])
                },
                contratoTarjeta: {
                    numerodecontrato: immCard.getIn(['contract', 'number']),
                    producto: immCard.getIn(['contract', 'product'])
                },
                diaOperacion: immMovement.getIn(['extra', 'dayMovementNumber']),
                estadoOperacion: immMovement.getIn(['extra', 'petitionState']),
                estandarDeReferencia: {
                    codigodeestandar: immCard.getIn(['product', 'standard']),
                    subtipodeproducto: {
                        subtipodeproducto: immCard.getIn(['product', 'subtype']),
                        tipodeproducto: {
                            tipodeproducto: immCard.getIn(['product', 'type'])
                        }
                    }
                },
                fechaAnotacion: immMovement.getIn(['extra', 'movementNoteDay']),
                fechaLiquidacion: immMovement.get('settlementDate'),
                fechaOperacion: immMovement.getIn(['extra', 'operationDate']),
                horaOperacion: immMovement.get('time'),
                importeOperacion: {
                    divisa: immMovement.getIn(['import', 'currency']),
                    importe: immMovement.getIn(['import', 'amount'])
                },
                modalidad: {
                    codmodalidadpago: immMovement.getIn(['extra', 'paymentModality']),
                    formapagotarjeta: immMovement.getIn(['extra', 'paymentMethod'])
                },
                numPlazosSeleccionados: parseInt(immCardPaymentPurchaseDeferral.getIn(['steps', FIRST_STEP, 'installmentQuantity'])),
                numTarjeta: immCard.get('number'),
                subtipoProd: {
                    subtipodeproducto: immCard.getIn(['product', 'subtype']),
                    tipodeproducto: {
                        tipodeproducto: immCard.getIn(['product', 'type'])
                    }
                },
                tipoSaldo: immMovement.getIn(['extra', 'balanceConcept'])
            }
        };

        dispatch(confirmDeferralRequest());
        return APIPost({
            dispatch,
            params,
            endpoint: 'cardPaymentPurchaseDeferral'
        })
            .then(response => dispatch(confirmDeferralSuccess(response)))
            .catch(response => {
                if (!!response.error) {
                    dispatch(confirmDeferralFailure(response.error.description));
                } else {
                    throw response;
                }
            });
    };

    return Promise.resolve().then(function() {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });
};

module.exports = {
    clearRequest,
    fetchRepayment,
    fetchSpecificRepayment,
    confirmDeferral,
    getSpecificQuotaRequest,
    setDefaultInstallmentQuantity,
    setDeferralOption,
    setQuotaQuantity,
    setSpecificQuotaAmount,
    setVisibleStep,
    setWillCancel,
    validateStep
};
